export const validatePersonalContactFields = (fields: {
  contact: string
  address: string
  permanentAddress: string
  emergencyName: string
  emergencyRelation: string
}) => {
  const errors: Record<string, string> = {};
  const addressPattern = /^(?=.*[A-Za-z])[A-Za-z0-9 .,'()#&/-]+$/;
  const contactTextPattern = /^(?=.*[A-Za-z])[A-Za-z0-9 .'-]+$/;

  if (!fields.contact?.trim()) {
    errors.contact = 'Please enter a Mobile Number.';
  } else if (!/^[6-9][0-9]{9}$/.test(fields.contact.trim())) {
    errors.contact = 'Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9';
  }

  (['address', 'permanentAddress'] as const).forEach((field) => {
    const value = fields[field]?.trim() || '';
    const label = field === 'address' ? 'Current address' : 'Permanent address';
    if (!value) errors[field] = `${label} is required.`;
    else if (value.length < 3 || value.length > 255 || !addressPattern.test(value)) {
      errors[field] = 'Enter a valid address (3–255 characters with letters and normal address punctuation).';
    }
  });

  const emergencyName = fields.emergencyName?.trim() || '';
  if (!emergencyName) errors.emergencyName = 'Emergency contact name is required.';
  else if (emergencyName.length < 2 || emergencyName.length > 100 || !contactTextPattern.test(emergencyName)) {
    errors.emergencyName = 'Enter a valid emergency contact name (2–100 characters with letters).';
  }

  const emergencyRelation = fields.emergencyRelation?.trim() || '';
  if (!emergencyRelation) errors.emergencyRelation = 'Emergency relation is required.';
  else if (emergencyRelation.length < 2 || emergencyRelation.length > 50 || !contactTextPattern.test(emergencyRelation)) {
    errors.emergencyRelation = 'Enter a valid emergency relation (2–50 characters with letters).';
  }

  return errors;
};
